/**
 * Indicates a prop is deprecated.  Initialize with old and new names...
 *   oldProp: propTypeDeprecated('oldPropName', 'newPropName')
 *
 * for which you'll get:
 *  Warning: Failed prop type: DEPRECATED prop 'oldPropName' was supplied to 'MyComponent.' Update to use 'newPropName' instead.
 *
 * @param {string} oldPropName
 * @param {string} newPropName (optional)
 */

const propTypeDeprecated =
  (oldPropName, newPropName) => (props, propName, componentName) => {
    if (propName === oldPropName && props[propName] !== undefined) {
      return new Error(
        `DEPRECATED prop '${propName}' was supplied to '${componentName}.'${
          newPropName && " Update to use '" + newPropName + "' instead."
        }`
      )
    }
  }

export default propTypeDeprecated
